export const ConnectPage = {
  loginForm: 'loginForm',
  guestForm: 'guestForm',
  detailsForm: 'detailsForm',
  transactionForm: 'transactionForm',
  connectPage: 'connectPage',
} as const;

export type ConnectPages = keyof typeof ConnectPage;

export enum ConnectWizardEvent {
  loginSuccessful = 'loginSuccessful',
  continueAsGuest = 'continueAsGuest',
  descriptionSubmitted = 'descriptionSubmitted',
  guestInfoFilled = 'guestInfoFilled',
  connectRequest = 'connectRequest',
  confirmConnectSupportRequest = 'confirmConnectSupportRequest',
  transactionSelected = 'transactionSelected',
  openRequestSelected = 'openRequestSelected',
  followup = 'followup',
  goBack = 'goBack',
}
